const require_Migration = require('./Migration.cjs');

//#region src/createMigration.ts
/**
* Creates a Prismic migration instance that can be used to prepare your
* migration to Prismic.
*
* @example
*
* ```ts
* createMigration()
* ```
*
* @typeParam TDocuments - A union of Prismic document types for the repository.
*
* @returns A migration instance to prepare your migration.
*/
const createMigration = () => new require_Migration.Migration();

//#endregion
exports.createMigration = createMigration;
//# sourceMappingURL=createMigration.cjs.map